import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { fromZodError } from 'zod-validation-error'

import { client } from '../../services/client'
import { makeServerResponseSchema } from '../../utils/schema'

async function fetchImglyLicense() {
  const response = await client.post('functions/imglyKey').json()

  const parsedResponse = makeServerResponseSchema(
    z.object({ license: z.string() })
  ).safeParse(response)

  if (!parsedResponse.success)
    throw new Error(fromZodError(parsedResponse.error).message)

  return parsedResponse.data.result
}

function useImglyLicense() {
  return useQuery({
    queryKey: ['imgly', 'license'],
    queryFn: fetchImglyLicense,
  })
}

export { useImglyLicense }
